<template>
  <div class="af">

    <p class="af-eyebrow">Welcome Back</p>
    <h1 class="af-h1">Sign in to continue</h1>
    <p class="af-sub">Your child's learning journey awaits.</p>

    <!-- Social buttons -->
    <div class="af-socials">
      <!-- Google -->
      <button type="button" class="af-social-btn af-social-google" :disabled="loading" @click="handleSocial('google')">
        <svg class="af-social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        Continue with Google
      </button>
      <!-- Apple -->
      <!-- <button type="button" class="af-social-btn af-social-apple" :disabled="loading" @click="handleSocial('apple')">
        <svg class="af-social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
        Continue with Apple
      </button> -->
      <!-- Facebook -->
      <!-- <button type="button" class="af-social-btn af-social-facebook" :disabled="loading" @click="handleSocial('facebook')">
        <svg class="af-social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
        Continue with Facebook
      </button> -->
    </div>

    <!-- Divider -->
    <div class="af-divider">
      <div class="af-divider-line"></div>
      <span class="af-divider-text">or</span>
      <div class="af-divider-line"></div>
    </div>

    <!-- Error -->
    <div v-if="error" class="af-error">{{ error }}</div>

    <!-- Form -->
    <form @submit.prevent="handleLogin" class="af-form">
      <div class="af-field">
        <label class="af-label">Email address</label>
        <input
          v-model="email"
          type="email"
          required
          placeholder="jane@example.com"
          class="af-input"
        />
      </div>
      <div class="af-field">
        <div class="af-label-row">
          <label class="af-label">Password</label>
          <a href="#" class="af-forgot" @click.prevent="openReset">Forgot password?</a>
        </div>
        <input
          v-model="password"
          type="password"
          required
          placeholder="Your password"
          class="af-input"
        />
      </div>
      <button type="submit" :disabled="loading" class="af-submit">
        <span v-if="loading" class="af-spinner"></span>
        {{ loading ? 'Signing in…' : 'Sign in' }}
      </button>
    </form>

    <!-- ── Password reset inline panel ── -->
    <div v-if="showReset" class="af-reset-panel">
      <p class="af-reset-title">Reset your password</p>
      <p class="af-reset-sub">We'll send a reset link to your email address.</p>
      <div v-if="resetSuccess" class="af-reset-success">
        ✓ Check your inbox — a reset link is on its way.
      </div>
      <template v-else>
        <div class="af-field">
          <label class="af-label">Email address</label>
          <input v-model="resetEmail" type="email" placeholder="jane@example.com" class="af-input" />
        </div>
        <div v-if="resetError" class="af-error" style="margin-top: 10px">{{ resetError }}</div>
        <div class="af-reset-btns">
          <button type="button" class="af-submit" style="flex:1" :disabled="resetLoading" @click="handleReset">
            {{ resetLoading ? 'Sending…' : 'Send reset link' }}
          </button>
          <button type="button" class="af-reset-cancel" @click="showReset = false">Cancel</button>
        </div>
      </template>
    </div>

    <p class="af-switch">
      Don't have an account?
      <RouterLink to="/auth/register" class="af-switch-link">Create one free</RouterLink>
    </p>

  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useStudentStore } from '@/stores/studentStore';

const router = useRouter();
const { login, loginWithSocial, sendPasswordReset, session, isOnboarded } = useAuth();
const studentStore = useStudentStore();

const email = ref('');
const password = ref('');
const error = ref('');
const loading = ref(false);

const showReset = ref(false);
const resetEmail = ref('');
const resetLoading = ref(false);
const resetError = ref('');
const resetSuccess = ref(false);

function openReset() {
  resetEmail.value = email.value; // pre-fill from login form
  resetError.value = '';
  resetSuccess.value = false;
  showReset.value = true;
}

async function handleReset() {
  resetError.value = '';
  resetLoading.value = true;
  try {
    await sendPasswordReset(resetEmail.value);
    resetSuccess.value = true;
  } catch (e) {
    resetError.value = 'Could not send reset email. Please check the address and try again.';
  } finally {
    resetLoading.value = false;
  }
}


const errorMessages = {
  INVALID_CREDENTIALS: 'Invalid email or password.',
};

async function redirectAfterLogin() {
  if (!isOnboarded.value) {
    router.push('/onboarding');
  } else {
    if (session.value?.uid) {
      await studentStore.loadChildren(session.value.uid);
    }
    router.push('/parent/dashboard');
  }
}

async function handleLogin() {
  error.value = '';
  loading.value = true;
  try {
    await login(email.value, password.value);
    redirectAfterLogin();
  } catch (e) {
    error.value = errorMessages[e.message] || 'Something went wrong. Please try again.';
  } finally {
    loading.value = false;
  }
}

async function handleSocial(provider) {
  error.value = '';
  loading.value = true;
  try {
    await loginWithSocial(provider);
    redirectAfterLogin();
  } catch (e) {
    error.value = 'Social login failed. Please try again.';
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.af { font-family: 'Jost', sans-serif; }

.af-eyebrow {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #B8902A;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.af-eyebrow::before {
  content: '';
  width: 24px;
  height: 1px;
  background: #B8902A;
  flex-shrink: 0;
}

.af-h1 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 34px;
  font-weight: 600;
  color: #0D1628;
  line-height: 1.15;
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}

.af-sub {
  font-size: 14px;
  color: #888;
  font-weight: 300;
  margin-bottom: 28px;
}

.af-socials {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 24px;
}

.af-social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  border-radius: 4px;
  padding: 11px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Jost', sans-serif;
  letter-spacing: 0.02em;
  border: 1.5px solid transparent;
}
.af-social-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.af-social-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Google: white bg, dark border, dark text */
.af-social-google {
  background: #fff;
  border-color: #dadce0;
  color: #3c4043;
}
.af-social-google:hover:not(:disabled) {
  background: #f8f9fa;
  box-shadow: 0 1px 6px rgba(0,0,0,0.1);
}

/* Apple: black bg, white text */
.af-social-apple {
  background: #000;
  border-color: #000;
  color: #fff;
}
.af-social-apple:hover:not(:disabled) {
  background: #222;
  border-color: #222;
}

/* Facebook: brand blue, white text */
.af-social-facebook {
  background: #1877F2;
  border-color: #1877F2;
  color: #fff;
}
.af-social-facebook:hover:not(:disabled) {
  background: #166FE5;
  border-color: #166FE5;
}

.af-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}
.af-divider-line {
  flex: 1;
  height: 1px;
  background: #e8e4da;
}
.af-divider-text {
  font-size: 11px;
  color: #bbb;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.af-error {
  margin-bottom: 18px;
  background: #fdf2f2;
  border: 1px solid #f5c6c6;
  color: #b91c1c;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 400;
}

.af-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.af-field { display: flex; flex-direction: column; gap: 6px; }

.af-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.af-label {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.af-forgot {
  font-size: 12px;
  color: #B8902A;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.af-forgot:hover { color: #d4a843; }

.af-input {
  width: 100%;
  border: 1.5px solid #e0dbd0;
  border-radius: 4px;
  padding: 11px 14px;
  font-size: 14px;
  font-family: 'Jost', sans-serif;
  font-weight: 400;
  color: #0D1628;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}
.af-input:focus { border-color: #B8902A; }
.af-input::placeholder { color: #bbb; }

.af-submit {
  width: 100%;
  background: #B8902A;
  color: #0D1628;
  border: none;
  border-radius: 4px;
  padding: 13px;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Jost', sans-serif;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 4px;
}
.af-submit:hover:not(:disabled) {
  background: #d4a843;
  transform: translateY(-1px);
}
.af-submit:disabled { opacity: 0.55; cursor: not-allowed; }

.af-spinner {
  display: inline-block;
  width: 11px;
  height: 11px;
  border: 2px solid rgba(13,22,40,0.3);
  border-top-color: #0D1628;
  border-radius: 50%;
  animation: af-spin 0.7s linear infinite;
  vertical-align: middle;
  margin-right: 6px;
}
@keyframes af-spin {
  to { transform: rotate(360deg); }
}

.af-switch {
  margin-top: 24px;
  text-align: center;
  font-size: 13px;
  color: #888;
  font-weight: 300;
}
.af-switch-link {
  color: #B8902A;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
}
.af-switch-link:hover { color: #d4a843; }

.af-reset-panel {
  margin-top: 20px;
  padding: 20px;
  background: #fdf8ee;
  border: 1.5px solid #e8d9a8;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.af-reset-title {
  font-size: 14px;
  font-weight: 700;
  color: #0D1628;
  margin: 0;
}
.af-reset-sub {
  font-size: 13px;
  color: #888;
  margin: 0;
  font-weight: 300;
}
.af-reset-success {
  font-size: 13px;
  color: #166534;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 4px;
  padding: 10px 14px;
  font-weight: 500;
}
.af-reset-btns {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}
.af-reset-cancel {
  flex: 0 0 auto;
  background: none;
  border: 1.5px solid #e0dbd0;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Jost', sans-serif;
  color: #888;
  cursor: pointer;
  transition: all 0.2s;
}
.af-reset-cancel:hover { border-color: #bbb; color: #555; }
</style>
